import { UserManager } from 'oidc-client-ts';

let userManager = null;

function getClientId() {
  return localStorage.getItem('oidc_client_id') || process.env.VUE_APP_OIDC_CLIENT_ID;
}

function createUserManager() {
  userManager = new UserManager({
    authority: process.env.VUE_APP_OIDC_AUTHORITY,
    client_id: getClientId(),
    redirect_uri: window.location.origin + '/callback',
    response_type: 'code',
    scope: 'openid profile api',
    post_logout_redirect_uri: window.location.origin,
    loadUserInfo: true
  });
}

export function login(clientId) {
  localStorage.setItem('oidc_client_id', clientId || process.env.VUE_APP_OIDC_CLIENT_ID);
  createUserManager();
  return userManager.signinRedirect();
}

export async function handleCallback() {
  if (!userManager) createUserManager();
  const user = await userManager.signinRedirectCallback();
  localStorage.setItem('token', user.access_token);
  localStorage.setItem('id_token', user.id_token);
  return user;
}

export function logout() {
  if (!userManager) createUserManager();
  return userManager.signoutRedirect();
}
